import { Component, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Nomination } from '../../core/models/nomination';

interface DetailRow {
  label: string;
  value: string;
}

@Component({
  selector: 'app-nomination-detail',
  templateUrl: './nomination-detail.component.html',
  styleUrls: ['./nomination-detail.component.scss'],
  providers: [DatePipe],
})
export class NominationDetailComponent {
  nomination: Nomination;
  rows: DetailRow[];
  displayedColumns = ['label', 'value'];

  constructor(@Inject(MAT_DIALOG_DATA) public data: { nomination: Nomination }, private datePipe: DatePipe) {
    this.nomination = data.nomination;
    this.rows = this.buildRows();
  }

  get showPositionGroup(): boolean {
    return this.nomination.recordType !== 'Sponsorship';
  }

  private buildRows(): DetailRow[] {
    const n = this.nomination;
    const rows: DetailRow[] = [];

    if (this.showPositionGroup) {
      rows.push({ label: 'Occupation', value: n.positionTitle || '-' });
      rows.push({ label: 'ANZSCO', value: n.occupationCode || '-' });
    }

    rows.push({ label: 'Status', value: n.status });
    rows.push({ label: 'Lodged', value: this.formatDate(n.lodgementDate) });
    rows.push({ label: 'Decided', value: this.formatDate(n.decisionDate) });
    rows.push({ label: 'Reference', value: n.reference || '-' });
    rows.push({ label: 'TRN', value: n.trn || '-' });
    rows.push({ label: 'Application ID', value: n.applicationId || '-' });

    return rows;
  }

  private formatDate(iso?: string): string {
    return iso ? this.datePipe.transform(iso, 'dd MMM yyyy') ?? '-' : '-';
  }
}
